import { render, staticRenderFns } from "./fileIcon.vue?vue&type=template&id=b0b3a46e&scoped=true"
import script from "./fileIcon.vue?vue&type=script&lang=js"
export * from "./fileIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b3a46e",
  null
  
)

export default component.exports